export default "__VITE_ASSET___zJxKGr1__"